import React from 'react';

import { PortalAccountsTable } from './PortalAccountsTable';
import styles from './styles/PortalAccountManagment.module.less';

export const PortalAccountsManagment = () => {
	return (
		<div className={styles.portalAccountManagment}>
			<PortalAccountsTable />
		</div>
	);
};
